
















import AmapSearch from 'vue-amap-search'
import 'vue-amap-search/dist/lib/main.css'
import { Component,Vue,Prop } from 'vue-property-decorator'

@Component({
    components:{
        AmapSearch
    }
})
export default class Map extends Vue{
    @Prop()
    value:any
    handleUserInput(){
            console.log(1232);
            
    }
    handlePickedLocation(e:any){
        this.$emit('location',e.location)
    }
}
